<template>
  <div
    class="flex-col justify-between relative self-stretch flex-wrap border border-secondary flex min-h-[140px] bg-white p-4 rounded-[8px] cursor-pointer select-none"
  >
    <div class="flex items-center justify-between w-full">
      <div class="h-3 w-1/4 bg-gray-200 animate-pulse rounded-xs"></div>
      <div class="h-3 w-1/6 bg-gray-200 animate-pulse rounded-xs"></div>
    </div>
    <div class="flex flex-col space-y-2 mt-4">
      <div class="flex space-x-2">
        <div class="w-full h-3 bg-gray-200 animate-pulse rounded-xs"></div>
      </div>
      <div class="flex space-x-2">
        <div class="w-full h-3 bg-gray-200 animate-pulse rounded-xs"></div>
      </div>
    </div>
    <div class="flex items-center justify-between mt-3">
      <div class="h-3 w-2/3 bg-gray-200 animate-pulse rounded-xs"></div>
      <div class="h-6 w-6 rounded-full bg-gray-200 animate-pulse"></div>
    </div>
  </div>
</template>

<script setup></script>
